import React from 'react';
import { AddressRuleCell } from '../../../inventory/addresses/address-rule-cell';
import { InfoMessage } from '../../../../shared/info-message/info-message';

type InfoAgMsgMsgProps = {
    ag: any;
}

export const InfoAgMsg: React.FC<InfoAgMsgMsgProps> = ({ag}) => {
    return (
        <InfoMessage
            header="Any changes to this address group will apply on all its associated rules:"
            contentComponent={AddressRuleCell}
            contentProps={{ addressGroupData: ag.data }}
        />
    );
};


